import { Modifier } from '../modifier';
import type { Damage } from '../damage.type';
import { ModifierPriority, ModifierTags, StatusEffect } from '../modifier.type';
import { StatusEffectRegistry } from '../status-effects';

export class Vulnerable extends Modifier {
  static readonly baseTitle = 'Vulnerable';
  static readonly baseText = 'Incoming damage is doubled, then fade.';
  static readonly baseIcon = 'vulnerable';
  static readonly baseTags = [ModifierTags.Bane];
  static readonly basePriority = ModifierPriority.Late;

  // Instance properties that can change
  title = Vulnerable.baseTitle;
  text = Vulnerable.baseText;
  icon = Vulnerable.baseIcon;
  tags: Array<ModifierTags> = [...Vulnerable.baseTags];
  priority = Vulnerable.basePriority;

  damageIn(damage: Damage) {
    damage.value *= 2;
    this.removeStacks(1);
  }
}

// Register the status effect
StatusEffectRegistry.register(StatusEffect.Vulnerable, Vulnerable);
